import { useMutation } from "@apollo/client";
import { updateNotificationMutation } from "GraphQL/queries/notifications";

export const  useVisionNotification = (isReadNotification,getUserData) =>{
    const [MyMutation] = useMutation(updateNotificationMutation);
    const changeNotification = (variables, updateType) => {
        MyMutation({ variables })
          .then(() => {
            if (updateType === "isRead") {
              isReadNotification();
            } else if (updateType === "delete") {
              getUserData();
            }
          })
          .catch((error) => console.log(error));
      };
return {
    changeNotification
}
}

